<template>
  <div>
    <div class="contract">
      <!-- <Header :groupService="dataContract.groupService"></Header> -->

      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">--------o0o--------</p>

      <p class="txt-tranf txt-center fonsize-20" style="margin-top: 20px; margin-bottom: 20px">
        <b>BIÊN BẢN THANH LÝ &<br />THOẢ THUẬN CHẤM DỨT HỢP ĐỒNG</b>
      </p>

      <p>
        - Căn cứ Hợp đồng hợp tác số
        <mark
          ><b>{{ dataContract.code }}</b></mark
        >
        ngày
        <mark
          ><b>{{
            dataContract.effectiveFromDTO
              ? dataContract.effectiveFromDTO
              : dataContract.dateSign | formatDate
          }}</b></mark
        >
        giữa Công ty Cổ phần Công nghệ Vi Mô và
        <mark
          ><b>{{ customerInfo.merchantName }}</b></mark
        ><br />
        <i>(Sau đây gọi tắt là “Hợp đồng”);</i>
      </p>

      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else>…… tháng …… năm 2026</mark>, tại Hà Nội; <br />
        Chúng tôi gồm:
      </p>

      <p class="fonsize-16 txt-tranf">
        <b>I. BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b>
      </p>

      <div>
        <p>Mã số doanh nghiệp: 0106393463 do Sở Kế hoạch và Đầu tư Thành phố Hà Nội cấp</p>
        <p>
          Trụ sở chính: Tầng 12A, Tòa nhà VTC Online, Số 18 đường Tam Trinh, Phường Tương Mai, Thành
          phố Hà Nội, Việt Nam.
        </p>
        <p>
          Đại diện: <b>Bà Nghiêm Vân Anh</b>
          <span class="ml-4">Chức vụ: <b>Giám đốc khối Vận hành</b></span>
        </p>
        <p>(Theo giấy UQ số: 1501/UQ-VIMO/2026 ngày 15 tháng 01 năm 2026)</p>
        <p>Điện thoại: 02436320986</p>
      </div>

      <p class="fonsize-16 txt-tranf" style="margin-top: 10px">
        <b
          >II. BÊN B: <mark>{{ customerInfo.merchantName }}</mark></b
        >
      </p>
      <div class="form form-ext">
        <p>
          Mã số thuế: <mark>{{ customerInfo ? customerInfo.businessRegistrationNumber : '' }}</mark>
        </p>
        <p>
          Trụ sở chính:
          <mark
            >{{ customerInfo ? customerInfo.address : ''
            }}<template v-if="customerInfo && customerInfo.district"
              >, {{ customerInfo.district }}</template
            ><template v-if="customerInfo && customerInfo.city"
              >, {{ customerInfo.city }}</template
            ></mark
          >
        </p>
        <p>
          Đại diện: <mark>{{ customerInfo ? customerInfo.customerName : '' }}</mark>
          <span class="ml-4"
            >Chức vụ: <mark>{{ customerInfo ? customerInfo.position : '' }}</mark></span
          >
        </p>
        <p>
          (Theo giấy UQ số
          <mark>...................................................................</mark>)
        </p>
        <p>
          Điện thoại: <mark>{{ customerInfo ? customerInfo.mobile : '' }}</mark>
          <span class="ml-4">Fax: <mark>....................................</mark></span>
        </p>
      </div>

      <br />
      <p>
        Sau đây Bên A và Bên B gọi chung là <b>“Bên”</b>, gọi riêng là <b>“Hai Bên”</b> hoặc
        <b>“Các Bên”</b> tùy ngữ cảnh.
      </p>
      <b><i>Hai Bên cùng nhau thống nhất thanh lý Hợp đồng, với các điều khoản như sau:</i></b>

      <p><b>Điều 1. Thoả thuận chấm dứt Hợp đồng</b></p>
      <p>
        1.1. Hai Bên thỏa thuận chấm dứt Hợp đồng kể từ ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else>….. tháng …. năm 2026</mark>.
      </p>
      <p>
        1.2. Tất cả quyền và nghĩa vụ của Hai Bên liên quan đến Hợp đồng nêu trên sẽ chấm dứt kể từ
        ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else>….. tháng …. năm 2026</mark> trừ các nội dung nêu tại Khoản 2.2, 4.2 Biên bản
        này.
      </p>

      <p><b>Điều 2. Nội dung chấm dứt hợp đồng</b></p>

      <p>2.1. Bên A và Bên B đã hoàn thành nghĩa vụ của mình theo quy định tại Hợp đồng.</p>
      <div>
        2.2. Trong vòng 60 (sáu mươi) ngày làm việc kể từ ngày chấm dứt Hợp đồng, Bên A và Bên B có
        trách nhiệm thực hiện các công việc sau đây thông qua hình thức trao đổi và xác nhận qua
        email chính thức đã đăng ký giữa hai Bên:
        <br />
        <p style="margin-left: 20px !important">
          a) Thanh quyết toán các giao dịch theo quy định tại Hợp đồng đã ký giữa hai Bên (nếu có);
        </p>
        <p style="margin-left: 20px !important">b) Phối hợp đối soát, tra soát giao dịch;</p>
        <p style="margin-left: 20px !important">c) Xác định công nợ/phí/hoàn trả (nếu có);</p>
      </div>

      <p><b>Điều 3. Quyền và nghĩa vụ của Các Bên</b></p>
      <p style="text-align: justify">
        3.1. Hai Bên có trách nhiệm hoàn thành mọi nghĩa vụ còn tồn đọng, hoàn tất việc thanh toán
        các khoản nợ còn lại giữa Hai Bên (nếu có), hoàn tất việc giải quyết các tra soát, khiếu nại
        có liên quan đến việc thực hiện các nội dung theo quy định của Hợp đồng và các Phụ lục Hợp
        đồng kèm theo trước khi chấm dứt Hợp đồng.
      </p>
      <p style="text-align: justify">
        3.2. Hai Bên đã thực hiện đầy đủ và nghiêm túc trách nhiệm và quyền hạn của mình theo đúng
        các quy định tại Hợp đồng đã ký.
      </p>
      <p style="text-align: justify">
        3.3. Các Bên thực hiện bảo mật thông tin, bảo vệ dữ liệu và lưu trữ hồ sơ/chứng từ theo quy
        định của pháp luật hiện hành, không sử dụng dữ liệu thu thập được trong quá trình hợp tác
        vào các mục đích ngoài phạm vi cho phép của Hợp đồng.
      </p>
      <p style="text-align: justify">
        3.4. Hai Bên không phát sinh tranh chấp hay vướng mắc nào trong quá trình thực hiện Hợp
        đồng.
      </p>

      <p><b>Điều 4. Điều khoản chung</b></p>
      <p style="text-align: justify">
        4.1. Biên bản có hiệu lực kể từ ngày được Các Bên ký kết, được lập thành 02 (hai) bản bằng
        tiếng Việt có giá trị như nhau. Mỗi Bên giữ 01 (một) bản làm cơ sở thực hiện.
      </p>
      <p style="text-align: justify">
        4.2. Việc chấm dứt hợp đồng hợp tác không làm chấm dứt hoặc miễn trừ nghĩa vụ và trách nhiệm
        của Bên B và Bên A trong việc giải quyết tra soát, khiếu nại của chủ thẻ/chủ tài khoản liên
        quan đến các giao dịch được thực hiện. Bên B có trách nhiệm tiếp tục phối hợp xử lý toàn bộ
        các yêu cầu tra soát, khiếu nại, tranh chấp; cung cấp đầy đủ, kịp thời hồ sơ, chứng từ theo
        yêu cầu của Bên A, ngân hàng, tổ chức thẻ liên quan theo quy định pháp luật; chịu trách
        nhiệm hoàn toàn về mặt tài chính phát sinh liên quan đến tra soát, khiếu nại, được xác định
        là lỗi của Bên B.
      </p>
      <p style="text-align: justify">Các Bên nhất trí thanh lý Hợp đồng.</p>
      <p style="text-align: justify; margin-bottom: 30px">
        Việc lập và ký Biên bản này hoàn toàn trên cơ sở tự nguyện, thiện chí, không bị lừa dối,
        cưỡng ép và không nhằm mục đích trốn tránh bất kỳ nghĩa vụ pháp lý nào theo quy định của
        pháp luật hiện hành.
      </p>

      <div class="table-responsive">
        <table class="table" style="border: unset !important">
          <tr>
            <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
              <p style="text-align: center !important">ĐẠI DIỆN BÊN A</p>
              <!-- <br /><br /><br /><br /><br /> -->
              <img
                src="@/assets/img/chu_ky_vimo_tl.jpg"
                style="width: 241px !important; height: auto !important"
                class="sign-block"
                alt=""
              />
              <p style="text-align: center !important; font-weight: bold">NGHIÊM VÂN ANH</p>
            </td>
            <td width="50%" align="center" style="vertical-align: top; border: 0 !important">
              <p style="text-align: center !important">ĐẠI DIỆN BÊN B</p>
              <img v-if="dataSign" :src="dataSign" class="sign-block" alt="" />
              <img
                v-else-if="
                  dataAppendix &&
                  dataAppendix.typeCustomer &&
                  dataAppendix.typeCustomer === 'COMPANY'
                "
                src="@/assets/img/signature.png"
                class="sign-block"
              />
              <img v-else src="@/assets/img/signature.png" class="sign-block" />
              <br />
              <br />
              <strong>{{ customerInfo.customerName }}</strong>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  // import Header from '../block/header.vue'
  // import Footer from '../block/footer.vue'

  export default {
    props: ['dataContract', 'appendix'],
    components: {
      // Header,
      // Footer,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract?.customerInfoRes ?? this.dataContract?.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return this.appendix || {}
      },
      dataSign() {
        if (this.dataAppendix?.isCreatedWithContract) {
          return this.dataContract?.signatureOfMerchantByContract?.[0] ?? null
        } else {
          return this.dataAppendix?.signatureOfMerchantByAppendix?.[0]
        }
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
<style scoped>
  .sign-block {
    width: 150px;
    height: 150px;
    display: inline-block;
  }
</style>
